import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header n-header">
      <div className="container n-header-content">
        <Link to="/" className="n-logo" onClick={closeMenu} aria-label="パーソナルジムN伏見 ホーム">
          <span className="n-logo-mark">N</span>
          <span className="n-logo-copy">
            <span>PERSONAL GYM</span>
            <small>FUSHIMI, NAGOYA</small>
          </span>
        </Link>

        <button
            className={`hamburger n-hamburger ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label={isMenuOpen ? 'メニューを閉じる' : 'メニューを開く'}
            aria-expanded={isMenuOpen}
            aria-controls="main-navigation"
        >
            <span></span>
            <span></span>
            <span></span>
        </button>

        <nav className={`nav n-nav ${isMenuOpen ? 'active' : ''}`} id="main-navigation" aria-label="Main navigation">
          <Link to="/" onClick={closeMenu}>HOME</Link>
          <Link to="/pricing" onClick={closeMenu}>PRICING</Link>
          <Link to="/trainer" onClick={closeMenu}>TRAINER</Link>
          <Link to="/faq" onClick={closeMenu}>FAQ</Link>
          <Link to="/access" onClick={closeMenu}>ACCESS</Link>
          <Link to="/recruit" onClick={closeMenu}>RECRUIT</Link>
          <a className="n-nav-cta" href="https://lin.ee/sPhllf4M" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
            BOOK A TRIAL <span aria-hidden="true">↗</span>
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;